const YINSHIMENG_APP_TITLE = '与牛共舞智能分析系统'

export function getAppTitle(empNo: unknown, defaultTitle: string) {
  return empNo === 'yinshimeng' ? YINSHIMENG_APP_TITLE : defaultTitle
}
